import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleModel.Delete.IRequest;
type Response = Api.Core.VehicleModel.Delete.IResponse;
type Headers = Api.Core.VehicleModel.Delete.IHeaders;
const url = '/api/ProductManagement/VehicleModel/:id';
export default async function vehicleModelDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
